import React from "react";
import { MailIconHoc } from "../../assets/images";
import ImageComponent from "./ImageComponent";
import { isUserWhoBlockedMe } from "../../Helpers/Chat/BlockContact";

const ProfileImage = ({
  emailContactInfo = false,
  userShortName = "",
  chatType,
  userToken,
  imageToken = "",
  temporary,
  emailId,
  onclickHandler = null,
  profileImageView = null,
  userId,
  name,
  ...props
}) => {
  const isUserBlockedMe = isUserWhoBlockedMe(userId);
  return (
    <div
      className={`profile-image ${emailContactInfo ? "email-info" : ""}`}
      onClick={onclickHandler ? onclickHandler : null}
    >
      <div className="image">
        <ImageComponent
          chatType={chatType}
          blocked={isUserBlockedMe}
          temporary={temporary}
          userToken={userToken}
          imageToken={imageToken}
          onclickHandler={profileImageView}
          // name={name}
         />
      </div>
      {emailId && (
        <i className="email-icon">
          <MailIconHoc viewBox="0 0 14 14" />
        </i>
      )}
    </div>
  );
};

export default ProfileImage;
